import { render, staticRenderFns } from "./finance-mng.vue?vue&type=template&id=2d18e669"
import script from "./finance-mng.vue?vue&type=script&lang=js"
export * from "./finance-mng.vue?vue&type=script&lang=js"
import style0 from "./finance-mng.vue?vue&type=style&index=0&id=2d18e669&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports